import React from 'react';
import usePurchaseTimeframeData from '../../hooks/usePurchaseTimeframeData';

const PurchaseTimeframeSelector = () => {

    const { getTimeframeOptions, getSelectedTimeframe, setTimeframeOption } = usePurchaseTimeframeData();

    const options = getTimeframeOptions();
    const selected = getSelectedTimeframe();

    const handleOptionClick = (id) => {
        setTimeframeOption(id);
    };

    return (
        <div>
            {options.length ? 
            <>
                <div className="component-header">
                    <h2>¿Cuándo quieres iniciar el proceso de compra?</h2>
                    <div className="component-subtitle">Selecciona cuando te gustaría iniciar el proceso de compra de tu Toyota</div>
                </div>
                <div className="component-body">
                    {options.map(option => (
                        <div 
                            className={"item-box " + (selected && option.id === selected.id ? 'active' : '')} 
                            key={`timeframe-${option.id}`} 
                            onClick={() => handleOptionClick(option)
                        }>
                            <div className="prepaid-maintenance">
                                <span className="name">{option.name}</span>
                            </div>
                        </div>
                    ))}
                    <div className={"item-box " + (!selected ? 'active' : '')} onClick={() => handleOptionClick(null)}>
                        <span>Solo estoy cotizando</span>
                    </div>
                </div>
            </>
            : null}
        </div>
    )
}

export default PurchaseTimeframeSelector;